export default "gmap-map-type-hybrid=Спутник\ngmap-map-type-roadmap=Карта\ngmap-sync-map-move=Менять список при перемещении карты\n"